var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "canvas_content",
      attrs: { id: _vm.canvasDomId },
      on: {
        drop: _vm.handleDrop,
        dragover: _vm.handleDragOver,
        mousedown: _vm.handleMouseDown,
        mouseup: _vm.deselectCurComponent,
        scroll: _vm.canvasScroll,
      },
    },
    [
      _c("de-editor", {
        ref: _vm.editorRefName,
        attrs: {
          "canvas-style-data": _vm.canvasStyleData,
          "component-data": _vm.componentData,
          "canvas-id": _vm.canvasId,
          "parent-forbid": _vm.parentForbid,
          "matrix-count": _vm.matrixCountBase,
          "out-style": _vm.outStyle,
          "scroll-top": _vm.scrollTop,
        },
        on: { canvasDragging: _vm.canvasDragging },
      }),
      _c("input", {
        ref: "files",
        attrs: { id: "input", type: "file", accept: "image/*", hidden: "" },
        on: {
          click: function (e) {
            e.target.value = ""
          },
          change: _vm.handleFileChange,
        },
      }),
      _vm.buttonVisible && _vm.panelInfo.id
        ? _c(
            "el-dialog",
            {
              attrs: {
                title:
                  (_vm.currentWidget &&
                  _vm.currentWidget.getLeftPanel &&
                  _vm.currentWidget.getLeftPanel().label
                    ? _vm.$t(_vm.currentWidget.getLeftPanel().label)
                    : "") + _vm.$t("panel.module"),
                visible: _vm.buttonVisible,
                "custom-class": "de-button-dialog",
                "append-to-body": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.buttonVisible = $event
                },
                close: _vm.cancelButton,
              },
            },
            [
              _vm.buttonVisible &&
              _vm.currentWidget &&
              _vm.currentWidget.name === "buttonSureWidget"
                ? _c("button-dialog", {
                    ref: "filter-setting-" + _vm.currentFilterCom.id,
                    attrs: {
                      "widget-info": _vm.currentWidget,
                      element: _vm.currentFilterCom,
                    },
                    on: {
                      "sure-handler": _vm.sureHandler,
                      "cancel-handler": _vm.cancelHandler,
                    },
                  })
                : _vm._e(),
              _vm.buttonVisible &&
              _vm.currentWidget &&
              _vm.currentWidget.name === "buttonResetWidget"
                ? _c("button-reset-dialog", {
                    ref: "filter-setting-" + _vm.currentFilterCom.id,
                    attrs: {
                      "widget-info": _vm.currentWidget,
                      element: _vm.currentFilterCom,
                    },
                    on: {
                      "reset-button-handler": _vm.sureHandler,
                      "cancel-button-handler": _vm.cancelHandler,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.filterVisible && _vm.panelInfo.id
        ? _c(
            "el-dialog",
            {
              attrs: {
                title:
                  (_vm.currentWidget &&
                  _vm.currentWidget.getLeftPanel &&
                  _vm.currentWidget.getLeftPanel().label
                    ? _vm.$t(_vm.currentWidget.getLeftPanel().label)
                    : "") + _vm.$t("panel.module"),
                visible: _vm.filterVisible,
                "custom-class": "de-filter-dialog min-width-730",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.filterVisible = $event
                },
                close: _vm.cancelFilter,
              },
            },
            [
              _vm.filterVisible && _vm.currentWidget
                ? _c("filter-dialog", {
                    ref: "filter-setting-" + _vm.currentFilterCom.id,
                    attrs: {
                      "widget-info": _vm.currentWidget,
                      element: _vm.currentFilterCom,
                    },
                    on: {
                      "sure-button-status": _vm.sureStatusChange,
                      "re-fresh-component": _vm.reFreshComponent,
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "end !important",
                    margin: "0 15px 10px !important",
                  },
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: { click: _vm.cancelFilter },
                        },
                        [_vm._v(_vm._s(_vm.$t("commons.cancel")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: !_vm.enableSureButton,
                            type: "primary",
                            size: "mini",
                          },
                          on: { click: _vm.sureFilter },
                        },
                        [_vm._v(_vm._s(_vm.$t("commons.confirm")))]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }